// Looking for My Account app, Protocol Pad, Search etc?
// They live as a standalone apps, i.e. in /my-account, /protocol-pad etc
// and, when compiling, insert themselves into theme assets like a baws
//
import { initToggleTargets, toggleHide } from "toggle-targets";
import { ALGOLIA } from "../../../common/src/Algolia";
import { AtoZMenus } from "../../bones/shopify-bones-a-z-menu"; // obsolete? replaced by categories-nav..
import "../../bones/shopify-bones-add-to-cart"; // svelte
import "../../bones/shopify-bones-alphabet-links"; // svelte IE11 format
import FlexTabs from "../../bones/shopify-bones-flextabs";
import "../../bones/shopify-bones-parse-video-src";
import "../../bones/shopify-bones-warning"; // cookie/covid warning and login popup
import "../../bones/shopify-bones-wishlist/dist/bundle.js"; // svelte
if (window.permanentDomain && ALGOLIA && ALGOLIA[window.permanentDomain]) {
  window.algolia = ALGOLIA[window.permanentDomain];
} else {
  console.error("ALGOLIA config not found for this store");
}
// require("./_tags");
require("./_slider");
require("./_validation");
require("./_newsletter-submit-scroll");
require("./_search-drop-class");
require("./_login-redirect");
require("./_add-tax-and-commission");
require("./_collections");
AtoZMenus();
require("./_tabs");
require("./_cart"); // all ought to be replaced by https://github.com/thetechdept/shopify-bones-cart
require("./_download-pdf-button");
require("./_sort-by");
require("./_menu-button");
require("./_forgot-password");
require("./_site-switcher");
const flexTabs = new FlexTabs();
window.toggleSets = initToggleTargets();

window.initSvelteAddToCarts && window.initSvelteAddToCarts(); // product detail pages

if (window.algolia) {
  // Product detail brands links
  document.querySelectorAll("[data-algolia-filter]").forEach((link) => {
    // Replace link HREF with algolia search filter url, a la
    // /search?shopify_an_uk_live_products%5BrefinementList%5D%5Bvendor%5D%5B0%5D=APE%20Nutrition
    const algoliaFilter = link.getAttribute("data-algolia-filter");
    const url = `/search?${window.algolia.indexName}${encodeURI(
      `[refinementList]${algoliaFilter}`
    )}`;
    link.href = url;
  });
}

// Spin up instances for any [data-totality] elements
import hasScrolled from "has-scrolled";
import Totality from "totality";
import visibilityClass from "visibility-class";
const totalityElements = document.querySelectorAll("[data-totality]");
if (totalityElements) {
  const totalities = [...totalityElements].map(
    (element) =>
      new Totality({
        element,
        currency: window.currencySymbol || "£",
      })
  );
}
hasScrolled();
visibilityClass(".shopify-section");
// Any nav links that target my account router links, close the nav modal
// E.g. you're already in the account section but using the main nav to get around
const accountLinks = document.querySelectorAll('[href^="/account#"]');
accountLinks &&
  accountLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      // Getting a bit messy, but it's the last days of Rome
      // toggleCloseSet({
      //   attribute: "data-toggle-target",
      //   setAttribute: 'data-toggle-set="1"'
      // });
      // Hey past Myke. You thought _those_ were the last days of Rome? So young.. so naive
      const toggleSetHeaderNav = window.toggleSets.filter(
        (t) => t.id == "header-nav-set"
      );
      toggleSetHeaderNav.forEach((set) => {
        set.targets.forEach((t) => {
          toggleHide(t);
        });
      });
    });
  });

const setBodyPadding = () => {
  const masthead = document.querySelector(".masthead");
  if (masthead) {
    document.body.style.paddingTop = `${masthead.offsetHeight}px`;
  }
};
window.addEventListener("resize", setBodyPadding);
setBodyPadding();
